<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content class="mat-typography">
    <div class="search-options-container">
        <div class="options-checkboxes">
            <mat-checkbox [(ngModel)]="options.searchOptions.includeDeleted">
                Include Deleted Documents
            </mat-checkbox>
            
            <mat-checkbox [(ngModel)]="options.searchOptions.fuzzySearch">
                Fuzzy Search
            </mat-checkbox>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" (click)="ok()" cdkFocusInitial>Ok</button>
</mat-dialog-actions>
